export default __webpack_public_path__ + "static/media/modx.6e1bee16.svg";